import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { Link } from 'react-router-dom';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

import { defaultUserImageUrl } from 'buyside/util/urlHelper';
import { truncateText } from 'buyside/util/textHelpers';

import { MessageItemFragment } from 'interfaces/graphql-typings';

import styles from './MessageIndexCardStyles.scss';

const MessageIndexCard: React.FC<{ isMobile: boolean; message: MessageItemFragment }> = ({
  isMobile,
  message
}) => {
  const {
    body,
    createdAt,
    isCapIntroMessage,
    otherParty,
    readStatus,
    senderIsCurrentUser,
    subject,
    threadCount
  } = message;

  const abbreviatedBody = truncateText(body, 120);

  let employerName = null;

  if (otherParty?.currentEmployerName) {
    employerName = otherParty.currentEmployerName;
  } else {
    if (otherParty?.mostRecentEmployer?.employer?.name)
      employerName = `Formerly at ${otherParty?.mostRecentEmployer?.employer?.name}`;
  }

  return (
    <Link
      className={classNames(styles.card, {
        [styles.unreadCard]: !readStatus,
        [styles.mobile]: isMobile
      })}
      to={`/${message.thread}`}
    >
      <div className={styles.userInformation}>
        <ProfileImage
          className={styles.profileImage}
          size="small"
          source={otherParty?.profileImageUrl || defaultUserImageUrl()}
        />
        {otherParty ? (
          <div>
            <div className={styles.displayName}>{otherParty.displayName}</div>
            {employerName && <div className={styles.employerName}>{employerName}</div>}
          </div>
        ) : (
          'Former User'
        )}
      </div>
      <div className={styles.body}>
        <div className={styles.subjectAndCount}>
          {subject} ({threadCount})
        </div>
        <div className={styles.latestMessageContainer}>
          <div className={styles.latestMessageSender}>
            {senderIsCurrentUser ? 'You' : otherParty?.displayName.split(' ')[0]}
            {': '}
          </div>
          <div className={styles.latestMessage}>{abbreviatedBody}</div>
        </div>
        <div className={styles.latestMessageDate}>
          {moment(createdAt).format('MMM DD, YYYY hh:mm a')}
        </div>
      </div>
      <div>{isCapIntroMessage && <span className={styles.capIntroMessage}>Cap Intro</span>}</div>
    </Link>
  );
};

export default MessageIndexCard;
